var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c(_setup.AppPage,{attrs:{"title":_setup.bankingInfo.stream.pastTense.charAt(0).toUpperCase() + _setup.bankingInfo.stream.pastTense.slice(1) + ' Wages',"subtitle":'Full list of ' +
    _setup.bankingInfo.stream.pastTense.charAt(0).toUpperCase() +
    _setup.bankingInfo.stream.pastTense.slice(1) +
    ' Wages',"icon":"exchange"},scopedSlots:_vm._u([{key:"custom-content",fn:function(){return [_c('b-col',[_c('b-card',[_c(_setup.StreamedWagesList)],1)],1)]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }